import arAR from './ar-AR';
import bgBG from './bg-BG';
import csCS from './cs-CS';
import daDK from './da-DK';
import deDE from './de-DE';
import elGR from './el-GR';
import enGB from './en-GB';
import esES from './es-ES';
import fiFI from './fi-FI';
import frFR from './fr-FR';
import heIL from './he-IL';
import hiIN from './hi-IN';
import huHU from './hu-HU';
import idID from './id-ID';
import itIT from './it-IT';
import jaJA from './ja-JA';
import koKO from './ko-KO';
import msMY from './ms-MY';
import nlBE from './nl-BE';
import nlNL from './nl-NL';
import noNO from './no-NO';
import plPL from './pl-PL';
import ptBR from './pt-BR';
import ptPT from './pt-PT';
import roRO from './ro-RO';
import ruRU from './ru-RU';
import skSK from './sk-SK';
import slSL from './sl-SL';
import svSE from './sv-SE';
import thTH from './th-TH';
import trTR from './tr-TR';
import uk from './uk';
import urPK from './ur-PK';
import vi from './vi';
import zhCN from './zh-CN';

export default {
  arAR,
  csCS,
  daDK,
  deDE,
  elGR,
  enGB,
  esES,
  fiFI,
  frFR,
  heIL,
  huHU,
  idID,
  itIT,
  jaJA,
  koKO,
  msMY,
  nlBE,
  nlNL,
  noNO,
  plPL,
  ptBR,
  ptPT,
  ruRU,
  skSK,
  slSL,
  svSE,
  thTH,
  trTR,
  zhCN,
  bgBG,
  roRO,
  uk,
  vi,
  hiIN,
  urPK,
};
